module.exports = __webpack_public_path__ + "static/img/community04.c9898ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community04.jpg
// module id = seed
// module chunks = 0